import { CREATE_ROTATIONSPLAN } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateRotationsplan/mutation';
import {
  Mitarbeiter_CreateRotationsplanMutation,
  Mitarbeiter_CreateRotationsplanMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateRotationsplan() {
  const [execute, result] = useMutation<
    Mitarbeiter_CreateRotationsplanMutation,
    Mitarbeiter_CreateRotationsplanMutationVariables
  >(CREATE_ROTATIONSPLAN, {
    refetchQueries: ['mitarbeiter_rotationsplaeneByStandortIds'],
    awaitRefetchQueries: true,
  });

  const createRotationsplan = useCallback(
    (variables: Mitarbeiter_CreateRotationsplanMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createRotationsplan, result] as const;
}
